/* KORZAVI — Halloween decoration.
   Loaded only while Admin → Content → Metaobjects → Store decoration says Halloween (or Auto, between the dates in Season scene). */
(() => {
  /* A ?decor= preview link can switch the season after this file was requested */
  if (document.documentElement.dataset.decor !== 'halloween') return;
  const $ = (s, c = document) => c.querySelector(s);
  const T = (window.KZ && window.KZ.strings) || {};
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const snd = (n, o) => { if (window.KZSound) window.KZSound.play(n, o); };
  const mk = (tag, cls, inner) => { const e = document.createElement(tag); e.className = cls; if (inner) e.innerHTML = inner; return e; };
  const button = (cls, label, inner) => { const b = mk('button', 'kzd-btn ' + cls, inner); b.type = 'button'; b.setAttribute('aria-label', label); return b; };
  const pulse = (el, cls, ms) => { el.classList.remove(cls); void el.offsetWidth; el.classList.add(cls); clearTimeout(el._t); el._t = setTimeout(() => el.classList.remove(cls), ms); };
  const header = $('[data-header]');
  const footer = $('.kz-footer');
  const hero = $('.hero');

  const SVG = {
    bat: '<svg viewBox="0 0 100 46" aria-hidden="true"><path d="M50 14c-2-5-5-8-5-8l-1 6c-4-2-9-1-11 3C26 7 15 3 0 6c8 4 12 11 12 19 5-5 12-5 16 1 3-5 9-6 13-1 2-4 5-6 9-6s7 2 9 6c4-5 10-4 13 1 4-6 11-6 16-1 0-8 4-15 12-19-15-3-26 1-33 9-2-4-7-5-11-3l-1-6s-3 3-5 8z"/></svg>',
    web: '<svg viewBox="0 0 100 100" aria-hidden="true"><g fill="none" stroke="currentColor" stroke-width=".8"><path d="M0 0L100 8M0 0L92 40M0 0L70 70M0 0L40 92M0 0L8 100"/><path d="M22 2Q20 10 20 9Q17 16 15 15Q11 18 9 20Q4 20 2 22"/><path d="M44 3Q41 18 40 18Q33 30 30 30Q20 34 18 40Q8 41 3 44"/><path d="M66 5Q62 26 60 27Q50 46 45 45Q30 52 27 60Q13 62 5 66"/><path d="M88 7Q83 35 80 35Q66 60 60 60Q41 69 36 80Q18 83 7 88"/></g></svg>',
    spider: '<svg viewBox="0 0 40 40" aria-hidden="true"><g stroke="#7c6a94" stroke-width="2" fill="none" stroke-linecap="round"><path d="M14 19L5 13 2 16M14 22L3 21 1 25M15 25L5 29 4 34M16 27L9 35 10 39M26 19l9-6 3 3M26 22l11-1 2 4M25 25l10 4 1 5M24 27l7 8-1 4"/></g><circle cx="20" cy="24" r="7.5" fill="#3a2d4c" stroke="#9a86b6" stroke-width=".8"/><circle cx="20" cy="14.5" r="4.6" fill="#3a2d4c" stroke="#9a86b6" stroke-width=".8"/><circle cx="18.3" cy="14" r="1.1" fill="#ff3b3b"/><circle cx="21.7" cy="14" r="1.1" fill="#ff3b3b"/><path d="M16.5 23.5q3.5 3 7 0" stroke="#b77bff" stroke-width="1.4" fill="none"/></svg>',
    pumpkin: '<svg viewBox="0 0 60 54" aria-hidden="true"><path d="M30 10c0-5 2-8 6-9" stroke="#3d7a2a" stroke-width="4" fill="none" stroke-linecap="round"/><ellipse cx="18" cy="32" rx="15" ry="19" fill="#e8620c"/><ellipse cx="42" cy="32" rx="15" ry="19" fill="#e8620c"/><ellipse cx="30" cy="32" rx="14" ry="20" fill="#ff7a1a"/><g class="kzd-face" fill="#ffd23f"><path d="M17 26l6-6 5 7z"/><path d="M43 26l-6-6-5 7z"/><path d="M15 36q15 12 30 0l-4 1-3 4-3-4-5 4-4-4-3 4-3-4z"/></g></svg>',
    ghost: '<svg viewBox="0 0 80 100" aria-hidden="true"><path d="M40 4C19 4 8 20 8 40v52l9-8 8 8 8-8 7 8 7-8 8 8 8-8 9 8V40C72 20 61 4 40 4z" fill="#f2f4fa" opacity=".94"/><ellipse cx="30" cy="38" rx="5" ry="7" fill="#141826"/><ellipse cx="50" cy="38" rx="5" ry="7" fill="#141826"/><ellipse cx="40" cy="56" rx="6" ry="8" fill="#141826"/></svg>'
  };

  /* Bats crossing the sky from time to time (decorative only) */
  if (!reduce) {
    const sky = mk('div', 'kzd-sky');
    sky.setAttribute('aria-hidden', 'true');
    [[14, 48, 26, 1], [24, 36, 31, 9], [36, 56, 37, 19]].forEach(([y, w, d, dl], i) => {
      const b = mk('span', 'kzd-bat' + (i === 1 ? ' kzd-bat--far' : ''), SVG.bat);
      b.style.cssText = `--y:${y}vh;--w:${w}px;--d:${d}s;--dl:${dl}s`;
      sky.appendChild(b);
    });
    document.body.appendChild(sky);
  }

  if (header) {
    /* Cobwebs in the top corners, behind the header content */
    ['l', 'r'].forEach((s) => {
      const w = mk('span', 'kzd-web kzd-web--' + s, SVG.web);
      w.setAttribute('aria-hidden', 'true');
      header.appendChild(w);
    });
    /* A spider hanging from the header; a click sends it back up */
    const thread = mk('div', 'kzd-spider');
    const spider = button('kzd-spider__b', T.decorSpider || 'Spider', SVG.spider);
    thread.appendChild(spider);
    header.appendChild(thread);
    spider.addEventListener('click', () => { pulse(thread, 'is-up', 2600); snd('squeak'); });
  }

  /* Pumpkins sitting on the top edge of the footer; a click lights them up */
  if (footer) {
    const row = mk('div', 'kzd-pumpkins');
    [46, 34, 40].forEach((s, i) => {
      const p = button('kzd-pumpkin', T.decorPumpkin || 'Pumpkin', SVG.pumpkin);
      p.style.setProperty('--s', s + 'px');
      p.style.setProperty('--dl', (i * 0.7) + 's');
      p.addEventListener('click', () => { pulse(p, 'is-lit', 1700); snd('laugh', { i }); });
      row.appendChild(p);
    });
    footer.appendChild(row);
  }

  /* A ghost peeking from the left edge of the home banner; it hides when the cursor comes close */
  if (hero) {
    const g = button('kzd-ghost', T.decorGhost || 'Ghost', SVG.ghost);
    const hide = (hover) => {
      if (g.classList.contains('is-hidden')) return;
      pulse(g, 'is-hidden', 2400);
      snd('boo', { hover });
    };
    g.addEventListener('pointerenter', (e) => { if (e.pointerType === 'mouse') hide(true); });
    g.addEventListener('click', () => hide(false));
    hero.appendChild(g);
  }
})();
